import { useQuery } from 'react-query';
import { FeaturedJob } from 'rwl-shared/dist/models';
import { useAPIRoute } from '../../hooks/useAPIRoute';
import { useGlobal } from '../../hooks';

type UseFetchJobParams = {
    jobId?: string | undefined;
    enabled?: boolean;
};

export const useFetchJob = ({ jobId, enabled }: UseFetchJobParams) => {
    const { accountId } = useGlobal();
    const url = useAPIRoute('serviceareas/featured/job', 'v1');

    return useQuery<FeaturedJob>(
        ['useFetchJob', accountId, jobId],
        async () => {
            if (!jobId || !accountId) {
                return undefined;
            }
            try {
                const result = await fetch(
                    `${url}?` +
                        new URLSearchParams({
                            accountId: accountId,
                            jobId: jobId,
                        }),
                    {
                        method: 'GET',
                    }
                );

                return result.json();
            } catch (e) {
                console.error('useFetchJob error:', e);
                throw e;
            }
        },
        {
            enabled: !!jobId && !!accountId && enabled,
            staleTime: 1000 * 60 * 60 * 24, // 24 hours
            cacheTime: 1000 * 10,
        }
    );
};
